import { ENDPOINT } from "../../network/ENDPOINT";
import { callApiToServer } from '../callApi';

function resolveToken(authToken) {
  return authToken || localStorage.getItem("token") || localStorage.getItem("admin_token") || "";
}

function buildHeaders(authToken) {
  const token = resolveToken(authToken);
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: "Berear " + token,
  };
}

/**
 * Fetch all registered cron jobs with their latest execution metadata
 */
export async function fetchCronJobsListAPI(authToken) {
  try {
    const header = buildHeaders(authToken);
    const body = JSON.stringify({});
    return await callApiToServer(body, header, "POST", ENDPOINT.cron_jobs_list);
  } catch (err) {
    throw err;
  }
}

/**
 * Fetch paginated 30-day run instances for a specific job
 */
export async function fetchCronJobRunsAPI(authToken, jobId, { page = 1, limit = 20, status = null } = {}) {
  try {
    const header = buildHeaders(authToken);
    const body = JSON.stringify({ page, limit, status });
    const endUrl = `${ENDPOINT.cron_job_runs}/${jobId}/runs`;
    return await callApiToServer(body, header, "POST", endUrl);
  } catch (err) {
    throw err;
  }
}

/**
 * Immediately execute a registered cron job on-demand
 */
export async function triggerCronJobNowAPI(authToken, jobId) {
  try {
    const header = buildHeaders(authToken);
    const body = JSON.stringify({});
    const endUrl = `${ENDPOINT.cron_job_run_now}/${jobId}/run-now`;
    return await callApiToServer(body, header, "POST", endUrl);
  } catch (err) {
    throw err;
  }
}

/**
 * Purge execution records older than specified retention days (default 30)
 */
export async function cleanupCronHistoryAPI(authToken, days = 30) {
  try {
    const header = buildHeaders(authToken);
    const body = JSON.stringify({ days });
    return await callApiToServer(body, header, "POST", ENDPOINT.cron_jobs_cleanup);
  } catch (err) {
    throw err;
  }
}
